import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/all-img/b-thub-1.png'
import _imports_1 from '../../assets/img/all-img/b-thumb-2.png'
import _imports_2 from '../../assets/img/all-img/b-thub-3.png'


const _hoisted_1 = { class: "edu-courses-area pt-70 pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8 col-md-12" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_7 = { class: "single-blog-standard" }
const _hoisted_8 = { class: "image" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "image"
}, null, -1)
const _hoisted_10 = { class: "content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Development")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour. ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-calendar" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 30, 2023")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-time-five" }),
    /*#__PURE__*/_createElementVNode("span", null, "3 Min Read")
  ])
], -1)
const _hoisted_14 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_15 = { class: "single-blog-standard" }
const _hoisted_16 = { class: "image" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "image"
}, null, -1)
const _hoisted_18 = { class: "content" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Drawing")
  ])
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, " There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour. ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-calendar" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 29, 2023")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-time-five" }),
    /*#__PURE__*/_createElementVNode("span", null, "3 Min Read")
  ])
], -1)
const _hoisted_22 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_23 = { class: "single-blog-standard" }
const _hoisted_24 = { class: "image" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "image"
}, null, -1)
const _hoisted_26 = { class: "content" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Technology")
  ])
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, " There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour. ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-calendar" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 22, 2023")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-time-five" }),
    /*#__PURE__*/_createElementVNode("span", null, "3 Min Read")
  ])
], -1)
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-12 col-md-12 col-sm-12\"><div class=\"pagination-area text-center\"><a href=\"#\" class=\"prev page-numbers\"><i class=\"bx bx-chevrons-left\"></i></a><span class=\"page-numbers current\" aria-current=\"page\">1</span><a href=\"#\" class=\"page-numbers\">2</a><a href=\"#\" class=\"page-numbers\">3</a><a href=\"#\" class=\"page-numbers\">4</a><a href=\"#\" class=\"next page-numbers\"><i class=\"bx bx-chevrons-right\"></i></a></div></div>", 1)
const _hoisted_31 = { class: "col-lg-4 col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SideBar = _resolveComponent("SideBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Financial Security Thinking and Principles Theory ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_12,
                  _hoisted_13
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Basic Fundamentals of Interior & Graphics Design ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_20,
                  _hoisted_21
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Introduction to Color Theory & Basic UI/UX ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_28,
                  _hoisted_29
                ])
              ])
            ]),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_SideBar)
        ])
      ])
    ])
  ]))
}